<template>
  <div class="tw-flex tw-items-center tw-cursor-pointer">
    <img 
      :src="require('@/assets/logo_Logo.png')" 
      alt="Turtlemeet Log" 
      class="tw-mr-1.5"
      :class="isPhone ? 'tw-h-6' : 'tw-h-8'"
    />
    <span class="tw-text-xl tw-font-medium" :class="{ 'tw-text-lg': isPhone }">Turtlemeet</span>
  </div>
</template>

<script>
import { isPhone } from "@/utils"

export default {
  name: "Logo",

  computed: {
    isPhone() {
      return isPhone(this.$vuetify)
    },
  },
}
</script>
